import cx from 'classnames'
import { ReactNode } from 'react'

import styles from './MarginArea.module.scss'

interface Props {
    top?: boolean
    bottom?: boolean
    left?: boolean
    right?: boolean
    xxs?: boolean
    xs?: boolean
    sm?: boolean
    md?: boolean
    lg?: boolean
    xl?: boolean
    xxl?: boolean
    auto?: boolean
    children?: ReactNode
    className?: string
}

const getClassNames = (props: Props) => [
    styles.margin,
    props.right && styles.right,
    props.left && styles.left,
    props.top && styles.top,
    props.bottom && styles.bottom,
    props.xxs && styles.xxs,
    props.xs && styles.xs,
    props.sm && styles.sm,
    props.md && styles.md,
    props.lg && styles.lg,
    props.xl && styles.xl,
    props.xxl && styles.xxl,
    props.auto && styles.auto,
    props.className,
]
export const MarginArea = (props: Props) => (
    <div className={cx(getClassNames(props))}>{props.children}</div>
)
